<form
  class="fs-7 d-flex flex-wrap gap-2"
  [formGroup]="filtersForm"
>
  <base-filter-dropdown
    [items]="statusItems"
    formControlName="status"
    filterName="state"
    optionClass="class"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="qualifications"
    filterName="qualifications.plural"
    formControlName="mainQualification"
    [searchable]="true"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="branches"
    filterName="provider"
    formControlName="pspBranch"
    [searchable]="true"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="departments"
    filterName="department.singular"
    formControlName="department"
    [searchable]="true"
    [displaySubLabel]="true"
    [optionSubLabelSegments]="['customerLocation', 'name']"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="locations"
    filterName="location.singular"
    formControlName="location"
    [searchable]="true"
  ></base-filter-dropdown>

  <base-datepicker
    [placeholder]="'inUseFrom' | translate"
    formControlName="fromDate"
    [isFilter]="true"
    [readonly]="true"
    [hideSelectedRange]="true"
    class="full-width"
  ></base-datepicker>

  <base-filter-dropdown
    *ngIf="!isWorkCouncil"
    [items]="openContractItems"
    filterName="contract"
    formControlName="openContract"
  ></base-filter-dropdown>
</form>
<hr *ngIf="activeFilters.length > 0" />
<div class="fs-7 d-flex align-items-center flex-wrap gap-2">
  <div
    *ngFor="let filter of activeFilters"
    class="px-2_5 rounded-pill bg-secondary py-2 active-filter fw-semibold"
  >
    <span class="pe-1 fw-normal">
      {{
        filter.filter === baseCustomerInquiryFilters.search
          ? ('search.nominative' | translate)
          : (labels[filter.filter] | translate)
      }}:
    </span>
    <span>
      {{ (filter?.name | translate) || (filter.value | baseFormatDate) }}
    </span>
    <i
      class="fa-solid fa-xmark ms-2 pointer"
      (click)="removeFilter(filter)"
    ></i>
  </div>
  <span
    *ngIf="activeFilters.length"
    class="pointer"
    (click)="clearFilters()"
  >
    {{ 'filter.reset' | translate }}
  </span>
</div>
